/*
    Looks like this is also the settings dialog for Pre-Factory Workspaces (pre_factoryfixture_devicegroup)
*/



let template = `<div id="dialog-devicegroup-settings" class="modal-dialog modal-lg production-device-group-settings">
    <div class="modal-content">
        <div class="modal-header">
            <div class="modal-title">
                Clone Device Group
                <span class="secondary-text">
                    {{name}}
                </span>
            </div>
            <button class="btn-close" data-dismiss="modal">X</button>
            <div class="modal-alert-container">
                <div class="alert"></div>
            </div>
        </div>
        <form>
            <div class="modal-body">
                <div class="form-group col-xs-6">
                    <label for="name">Device Group Name</label>
                    <input type="text" maxlength="100" name="name" placeholder="Enter a name..." class="form-control name" />
                    <span class="help-block name-counter">0 / 100</span>
                    <label for="description">Device Group Description</label>
                    <textarea class="form-control description" name="description" maxlength="300" placeholder="Enter description here"></textarea>
                    <span class="help-block description-counter">0 / 300</span>
                    <div class="form-group region-dropdown"></div>
                    <div class="account-region"></div>
                    <div class="product-region"></div>
                </div>
                <div class="form-group col-xs-6">
                    <div class="environment-variables">
                        <label for="env_vars">Environment Variables</label>
                        {{#if edit_env_vars}}
                            <textarea rows="6" class="form-control env_vars" name="env_vars"
                                placeholder="Write Environment Variables here as valid JSON">{{env_vars}}</textarea>
                            <span class="help-block">Custom variables that can be used in the Device Group's code. Only Owners have permissions to edit. 
                            Must be valid JSON.  Keys must be alphanumeric, and start with a letter.
                            Values must be strings or numbers. A new deployment will need to be created, and devices restarted.</span>
                            <pre class="help-block code">e.g. {"foo":"bar"}</pre>
                        {{else}}
                            {{#if show_env_vars_keys}}
                                <pre class="code">{{env_vars_keys}}</pre>
                                <span class="help-block">Custom Variables to use in this Device Group's code. Only Owners have permissions to edit. 
                                Values may be strings, booleans, or numbers.</span>
                            {{/if}}
                        {{/if}}
                    </div>
                </div>



                <div class="form-group totp-form">
                    <label for="totp-input">This account requires MFA for Production Deployments, enter your code below.</label>
                    <input type="text" maxlength="6" name="totp-input" placeholder="Enter Code" class="form-control totp-input" />
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-link" data-dismiss="modal">cancel</button>

                <button type="submit" class="btn btn-primary submit" disabled>Clone</butto>
            </div>
        </form>
    </div>
</div>`;

import Radio from 'backbone.radio';
import Backbone from 'backbone';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import _ from 'underscore';
import DialogInterface from '@/interfaces/dialog';
import PaginatedMenuView from '@/views/paginated_menu_view';
import ProductSelector from '@/views/modules/product_selector';
import AccountSelector from '@/views/modules/account_selector';
import strings_specific from 'amdi18n-loader!@/nls/dut_device_group_settings';
import strings_common from 'amdi18n-loader!@/nls/common';

    var strings = _.extend({}, strings_common, strings_specific);
    var MAX_DESCRIPTION_LENGTH = 300;
    var MAX_NAME_LENGTH = 100;

    function perm_check(active, primary, type){
        if ( type === 'dut_devicegroup' && active.permits(primary, 'update_factory_vars') ) {
            return true;
        } else if ( type === 'pre_dut_devicegroup' && active.permits(primary, 'update_pre_factory_vars') ){
            return true;
        }
        return false;
    }

    const globalCh = Radio.channel('global');
    const apiCh = Radio.channel('api');
    
    const view = Marionette.View.extend(DialogInterface).extend({
        template: Handlebars.compile(template),
        changed: {
            load_code_after_blessing: false,
        },
        on_success: function () {
            this.closeDialog();
        },
        initialize: function (options) {
            this.owner = this.model.rel.get('owner');
            this.product = this.model.rel.get('product');
            this.deployment = this.model.rel.get('current_deployment');
            if (this.deployment) this.deployment.fetch();
            this.destroyOnClose();
            this.focusFirstInput();
            _.bindAll(this, 'handle_success', 'handle_error');
        },
        ui: {
            code_list_label: '.code-list-label',
            submit: '.btn.submit',
            tooltips: '[data-toggle="tooltip"]',
            inputs: 'input',
            forms: '.form-control',
            name: '.form-control.name',
            description: '.form-control.description',
            name_length_counter: '.name-counter',
            description_length_counter: '.description-counter',
            region_dropdown: '.region-dropdown',
            region_label: '.region-label',
            totp_form: '.totp-form',
            totp_input: '.totp-input',
            env_vars: '.environment-variables',
            env_vars_textarea: '.environment-variables textarea',
            account_region: '.account-region',
            product_region: '.product-region'
        },
        regions: {
            account_region: '@ui.account_region',
            product_region: '@ui.product_region',
            region_menu: '@ui.region_dropdown',
        },
        templateContext: function () {
            var active = globalCh.request('active_account');
            var primary = globalCh.request('primary_account');
            let is_create = true;
            let name = this.model.get('name');
            let type = this.model.type;

            let env_vars = null;
            let env_vars_keys = null;
            let edit_env_vars = false;
            let show_env_vars_keys = false;

            let products = apiCh.request('product');
            let selected_product = this.model.rel.get('product').id;
            
            if ( this.model && this.model.get('env_vars') ) { 
                env_vars = JSON.stringify(this.model.get('env_vars'), null, 4);
            }
            if ( perm_check(active, primary, type ) ) {
                edit_env_vars = true;
            } else {
                show_env_vars_keys = true;
                if ( this.model && this.model.get('env_vars') ) {
                    env_vars_keys = Object.keys(this.model.get('env_vars'));
                }
            }
            
            if ( !env_vars_keys ) env_vars_keys = "no variables";

            return _.extend({}, strings, {
                name: name,
                type: this.model.type_readable(),
                is_create: is_create,
                show_env_vars_keys: show_env_vars_keys,
                edit_env_vars: edit_env_vars,
                env_vars: env_vars,
                env_vars_keys: env_vars_keys,
                products: products.models,
                selected_product
            });
        },
        onRender: function () {
            this.ui.tooltips.tooltip({
                placement: 'bottom',
                title: '<div>' + strings.tooltip_1 + '</div><div><strong>' + strings.blessing + '</strong>' + strings.tooltip_2 + '</div><div><strong>' + strings.blinkup + '</strong>' + strings.tooltip_3 + '</div>',
                html: true,
                template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
            });

            if ( !this.mfa_required() ) this.ui.totp_form.hide();
            this.ui.name.val( this.model.get('name') );
            this.ui.description.val( this.model.get('description') );
            this.validate();
            this.maybeShowRegionsMenu();

            this.showChildView('account_region', new AccountSelector({ model: this.model }));
            this.render_products(this.owner.id); 
        },
        render_products: function(val) {
            let products = apiCh.request('product');
            products.fetch({
                data: {
                    'filter[owner.id]': val,
                    'page[size]': 100
                },
            }).then((resp)=>{
                this.showChildView('product_region', new ProductSelector({ model: this.model, products: resp.data }));
            });
        },
        change_product: function(val) {
            this.product = apiCh.request('product', { id: val });
        },
        change_account: function(val) {
            this.render_products(val);
            this.owner = apiCh.request('account', { id: val });
            this.maybeShowRegionsMenu();
        },
        events: {
            'click @ui.submit': function (e) {
                this.submit(e);
            },
            'keyup': 'validate',
            'paste': 'validate',
            'change': 'validate',
            'mouseup': 'validate',
            'choose': 'validate',
        },
        childViewEvents: {
            'change:account' : 'change_account',
            'change:product' : 'change_product'
        },
        validate: function() {
            if ( !this.validate_description()
                    || !this.validate_name()
                    || !this.validate_deployment()
                    || !this.validate_totp()
            ){
                this.ui.submit.prop('disabled', true);
                return false;
            }

            this.ui.submit.prop('disabled', false);
            return true;
        },
        validate_deployment: function () {
            if ( this.deployment || this.model ) return true;
            return false;
        },
        validate_description: function () {
            this.check_validation(
                this.ui.description,
                MAX_DESCRIPTION_LENGTH,
                this.ui.description_length_counter
            );
            if ( this.ui.description.val() ) return true;
            // description is not required, but we still need to check the length
            return true;
        },
        validate_name: function () {
            this.check_validation(
                this.ui.name,
                MAX_NAME_LENGTH,
                this.ui.name_length_counter
            );
            if ( this.ui.name.val() ) return true;
            return false;
        },
        validate_totp: function () {
            if ( this.mfa_required() && this.ui.totp_input.val().length < 6 ) {
                return false;
            }
            return true;
        },
        submit: function (e) {
            if (e) {
                e.preventDefault();
                if (e.target.classList.contains('disabled')) {
                    return;
                }

            }
            this.hideAlert();
            let name,
                description;
            name = this.ui.name.val().trim();
            description = this.ui.description.val().trim();
            this.create(name, description);
        }, 
        create: function (name, description, load_code_after_blessing, region) {
            var devicegroups = apiCh.request(this.model.type);
            var product = this.product;
            var cloud_regions = apiCh.request('cloud_regions');
            var selected_region = null;
            var region_menu = this.getRegion('region_menu');
            var active = globalCh.request('active_account');
            var primary = globalCh.request('primary_account');

            if (cloud_regions && cloud_regions.length > 0 && this.options.type !== 'dut_devicegroup' && this.options.type !== 'pre_dut_devicegroup') {
                selected_region = region_menu.currentView.selected_child;
            }
           
            var opts = {
                name: name,
                type: this.model.type,
                description: description
            };

            if (cloud_regions && cloud_regions.length > 0 && selected_region && selected_region.get('name') != 'Default' ) {
                opts.region = selected_region.get('name');
            } 

            if ( perm_check(active, primary, opts.type ) ) {
                let env_vars_string = this.ui.env_vars_textarea.val();
                let env_vars = null;
                let error = {
                    responseJSON : {
                        errors: []
                    }
                };
        
                try {
                   env_vars = JSON.parse(env_vars_string);
                } catch ( e ) {
                    if ( env_vars_string && env_vars_string.length > 0 ) {
                        error.responseJSON.errors.push({
                            detail: {
                                message : e.toString()
                            }
                        });
                    }
                }
        
                if ( error.responseJSON.errors.length > 0 ) {
                    this.handle_error(error);
                    return;
                }
                let env_vars_keys = null;

                if (env_vars) {
                        env_vars_keys = Object.keys(env_vars);
                        env_vars_keys.forEach( (k) => {
                        if ( typeof env_vars[k] !== 'string' && !isFinite(env_vars[k]) ) {
                                error.responseJSON.errors.push({
                                            detail: {
                                                message : 'Illegal value for ' + k + '. Values must be strings or finite numbers. '
                                            }
                                        }
                                );
                        } else if ( typeof env_vars[k] === 'boolean' ) {
                            error.responseJSON.errors.push({
                                        detail: {
                                            message : 'Illegal value for ' + k + '. Values must be strings or finite numbers. '
                                        }
                                    }
                            ); 
                        }
                    });
                }
        
                if ( error.responseJSON.errors.length > 0 ) {
                    this.handle_error(error);
                    return;
                }
                opts.env_vars = env_vars;
            }

            return devicegroups.create(opts,
            {
                product: product,
                wait: true,
                success: function(model, response){
                    this.clone_model = model;
                    if ( this.deployment ) { 
                        this.deploy_to_new_production_devicegroup(this.clone_model);
                    } else {
                        this.handle_success();
                    }
                }.bind(this),
                error: function (model, err) {
                    this.handle_error(err);
                }.bind(this),
            });
        },
        
        deploy_to_new_production_devicegroup: function() {
            var totp = this.ui.totp_input.val();
            var headers = {};
            if ( this.mfa_required() ) {
                headers = {
                    'x-electricimp-otp-token': totp
                };
            }
            let deployments = apiCh.request('deployment');
            if ( !this.deployment || !this.deployment.type ) return;
            var options = {
                type: this.deployment.type,
                attributes: {
                    description: this.deployment.get('description'),
                    agent_code: this.deployment.get('agent_code'),
                    device_code: this.deployment.get('device_code')
                },
                relationships: {
                    devicegroup: this.clone_model.toReference(),
                }
            };
            deployments.create(
                options,
                {
                merge: true,
                // Without wait: true, ID is undefined 
                wait: true,
                headers: headers,
                success: function(model, response){
                    this.handle_success();
                }.bind(this),
                error: function(model, resp) {
                    this.handle_error(resp);
                }.bind(this),
            });
        },
        maybeShowRegionsMenu: function() {
            this.ui.region_label.hide();
            if (!this.getOption('show_regions')) {
                return;
            }
            var cloud_regions = apiCh.request('cloud_regions');
            var cloud_collection;
            var view_opts;
            if ( cloud_regions && cloud_regions.length > 0) {
                this.ui.region_label.show();
                cloud_collection = new Backbone.Collection();
                // add assumed "default" region
                cloud_collection.add(new Backbone.Model({id: 'Default', name: 'Default'}));
                _.each(cloud_regions, function(r) { cloud_collection.add(new Backbone.Model({id: r, name: r})); });
                view_opts = {
                    title: 'Choose a Region',
                    collection: cloud_collection,
                    childView: Marionette.View
                };
                let view = new PaginatedMenuView(view_opts);
                this.showChildView('region_menu', view);
            }
        },
        chooseDeployment: function (deployment) {
            this.deployment = deployment;
            this.validate();
        },
        // boolean variable if mfa is required for creating production deployments
        mfa_required: function() {
            if ( this.model ) return false;
            return this.model.rel.get('owner').get('deployment_mfa_required') && this.options.type === 'production_devicegroup';
        },
        handle_error: function (err) {
            this.showAlert('alert-danger', err);
        },
        handle_success: function (model, response, options) {
            this.closeDialog();
            Radio.request('alerts', 'showAlert', {
                message: "Successfully updated settings of " + this.model.get('name'),
                messageType: 'success'
            });
        }
    });
    export default view;


